import { tooltip } from './_base';

const Ammo = () => {
  let value = 0;

  return {
    value,
    label: 'Ammo',
    isCarried: true,
    tooltip: () => tooltip('ammo'),
    min: 0
  };
};

export default Ammo;
